/**
 *
 * Disclaimer: Source code mentioned below is(are) Intellectual Property of
 * Crayon Data Holdings Limited (including its subsidiaries and affiliates).
 * Crayon Data Holdings Limited reserves right to own and control it the way
 * it may deem fit. You must refrain from use, access, read, modify, add or
 * delete, sell or use in any other package or programme pertaining to such
 * source code without explicit prior written approval of
 * Crayon Data Holding Limited. Breach of the same shall attract penalty as
 * applicable.
 *
 */

// MerchantDetails Component
import React, { PureComponent, useEffect } from "react";
import ContentLoader from "react-content-loader";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Popover } from "react-tiny-popover";
import Breadcrumb from "../../components/Bredcrumb";
import Icon from "../../components/Icons";
import Image from "../Image";
import MenuBar from "../MenuBar";
import CardList from "../CardList";
import Select from "../Select";
import BestOffer from "../Best_Offer";
import BankBestOffer from "../Best_Offer_Bank";
import MerchantCardCarousel from "../Merchant_Card_Carousel";
import MerchantInfo from "../Merchant_Info";
import Review from "../Review";
import SettingModal from "../Offer_Setting";
import ShareAlert from "../ShareAlert";
import { Modal } from "../Modal";
import "./index.scss";
import { interaction, getError, checkColor, tobase64 } from "../../service";
// import Color from "color-thief-react";
import SimilarMerchants from "../Similar_Merchants";
// import HeartUnFilled from "../../assets/img/heartunfilled.png";
// import merchant_detail_background from "../../assets/img/details_bg.png";
import merchant_detail_background_ar from "../../assets/img/details_bg_arab.png";
import HeartFilled from "../../assets/img/heart_new_filled.png";
// import settings1 from "../../assets/img/settings1.png";
import { toTitleCase } from "../../pages/helper";
import { withRouter } from "react-router";
import uiConfig from "../../uiConfig";
import GaugeChart from "react-gauge-chart/dist/GaugeChart";
import ShareModal from "../Share";
import { set } from "js-cookie";
import { arabicContent } from "../../constants/index";
import config from "../../service/config";
import HeartUnFilled from "../../assets/img/heartunfilled.png";
// import merchant_detail_background from "../../assets/img/details_bg.png";
import merchant_detail_background from "../../assets/img/details_bg.png";
import axios from "axios";
var MatomoTracker = require("matomo-tracker");
var matomo = new MatomoTracker(config.siteId, config.siteURL);

class MerchantDetails extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeMenu: "bestOffers",
      country:
        JSON.parse(localStorage.getItem("selectCountry")) ||
        JSON.parse(localStorage.getItem("selectFirstCountry")),
      showMore: false,
      width: window.innerWidth,
      isLoad: true,
      isPopoverOpen: false,
      like: false,
      dislike: false,
      isShareOpen: false,
      changeCountryCheck: false,
      activeOfferIndex: -1,
      imgSrc: "",
      expirePopup: false,
      near : true,
      merchantData: this.props.item,
      porttype:true,
      from:""
    };
    this.simRef = React.createRef();
  }

  componentDidMount() {
    const { history, item } = this.props;
    const itemtype = this.props.item.itemType 
    const searchParams = new URLSearchParams(this.props.location.search)
    const type = searchParams.get('type');
    const from = searchParams.get('from');
    this.setState({from:from})
    this.updateWindowDimensions();
    this.uploadLoader();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.scrollTo(0, 0);
    if(itemtype === "PORTFOLIO_OFFERS"){
      this.setState({porttype:false});
    }
    else{
      this.setState({porttype:true});
    }
    if(this.state.country?.value === "Near me"){
      this.setState({ country: {value: "near you"} });
      this.setState({near:false})
    }
    let offers = item.offers || [];
    if (offers.length === 0) {
      this.setState({ expirePopup: true });
    } else {
      let temp = [];
      let curLoc = false;
      let otherLoc = false;
      offers.forEach((x) => {  
        if (x?.isExpired) temp.push(x);
        if(x?.currentLocation){
          curLoc = true;
        } else {
          otherLoc = true;
        }    
        // if (x?.currentLocation) loc.push(x);
      });
      this.setState({IsCurLocation:curLoc})
      this.setState({IsOtherLocation:otherLoc})
      if (temp.length === offers.length) {
        this.setState({ expirePopup: true });
      }
    }
    setTimeout(() => {
      if (this.state.expirePopup && this.state.from !== "expired") history.push("/home");
    }, 15000);
    if(localStorage.getItem("merchantDL")) {
          
      console.log("")
    }
    else {
      matomo.track({
        url: window.location.href,
        e_c: this.props.item?.category,
        e_a: "DEEPLINKING_MERCHANT",
        e_n: this.props.item?.id
      });
    }
    localStorage.removeItem("merchantDL")
  }

  componentDidUpdate(prevProps) {
    const { history, item } = prevProps;
    let offers = item.offers || []; 
    let curLoc = false;
    let otherLoc = false;
    if(prevProps === this.props){
      offers.forEach((x) => {  
        if(x?.currentLocation){
          curLoc = true;
        } else {
          otherLoc = true;
        }
      })
      this.setState({IsCurLocation:curLoc})
      this.setState({IsOtherLocation:otherLoc})
    }
    if (prevProps.item.id !== this.props.item.id) {
      const itemtype = this.props.item.itemType
      if(itemtype === "PORTFOLIO_OFFERS"){
        this.setState({porttype:false});
      }
      else{
        this.setState({porttype:true});
      }
    }
    if (this.props.location?.state?.page === "similarItem") {
      let merObject = { id: prevProps.item?.id, name: prevProps.item?.name };
      sessionStorage.setItem("prevMerchant", JSON.stringify(merObject));

      let arr = [];
      arr = JSON.parse(sessionStorage.getItem("merArr")) || [];
      arr.push(merObject);

      const ids = arr.map((o) => o.id);
      const filtered = arr.filter(
        ({ id }, index) => !ids.includes(id, index + 1)
      );
      if (prevProps.item.id !== this.props.item.id) {
        this.setState({ merchantData: this.props.item });
      }
      sessionStorage.setItem("merArr", JSON.stringify(filtered));
    }
  }

  componentWillUnmount() {
    sessionStorage.setItem("merArr", null);
  }

  checkColor = async () => {
    // const {item} = this.props;
    // let imgSrc=""
    // let imageExists=await checkColor("https://logo.clearbit.com/"+item.url.replace("//", "/")+"?size=800");
    // if(imageExists) {
    //   imgSrc="https://logo.clearbit.com/"+item.url.replace("//", "/")+"?size=800"
    //   this.setState({
    //     loading:false,
    //     imgSrc:imgSrc
    //   })
    // } else {
    //   await tobase64(item.image.replace(/%20/g, " ")).then(
    //   img=> {
    //     if(img) {
    //       if(item.image.match(/.(png)$/i)) {
    //         imgSrc="data:image/png;base64,"+img
    //       } else if(item.image.match(/.(jpg)$/i)) {
    //         imgSrc="data:image/jpg;base64,"+img
    //       }
    //       this.setState({
    //         loading:false,
    //         imgSrc:imgSrc
    //       })
    //     }
    //   }
    //   ).catch(err=>{
    //     imgSrc=item.image;
    //     this.setState({
    //       loading:false,
    //       imgSrc:imgSrc
    //     })
    //   })
    // }
  };

  uploadLoader() {
    // setTimeout(() => {
    //Start the timer
    this.setState({ isLoad: false }); //After 5 second, set render to true
    // }, 5000);
  }

  userInteraction = (itemId, type) => {
    var imgSrc = document.getElementById(itemId).getAttribute("data");
    if (imgSrc == "WISHLIST") {
      if (localStorage.getItem("USERID") === null) {
        this.props._openLogin();
        localStorage.setItem("interactionType", "WISHLIST");
        localStorage.setItem("interactionId", itemId);
        this.props.item.itemType==="PORTFOLIO_OFFERS"? localStorage.setItem("interactionFrom", "PORTFOLIO_OFFERS") : localStorage.setItem("interactionFrom", "Merch");
      }
      if (localStorage.getItem("USERID")) {
        let data = { ...this.state.merchantData };
        data.wishlisted = true;
        this.setState({
          merchantData: data,
        });
        document.getElementById(itemId).setAttribute("data", "UNDO_WISHLIST");
        document.getElementById(itemId).src = HeartFilled;
        if(this.props.item.itemType==="PORTFOLIO_OFFERS"){

          interaction("WISHLIST", "PORTFOLIO_OFFERS", itemId)
            .then((res) => {})
            .catch((err) => {
              if (err && err.data && err.data.status === 404) {
              } else {
                //console.log(getError(err));
              }
            });
        }
        else if(this.props.item.itemType==="FINANCIAL_PRODUCT"){
          interaction("WISHLIST", "FINANCIAL_PRODUCT", itemId)
          .then((res) => {})
          .catch((err) => {
            if (err && err.data && err.data.status === 404) {
            } else {
              //    console.log(getError(err));
            }
          });
         }
          else{
        interaction("WISHLIST", "MERCHANT", itemId)
          .then((res) => {})
          .catch((err) => {
            if (err && err.data && err.data.status === 404) {
            } else {
              //    console.log(getError(err));
            }
          });
      }
      matomo.track({
        url: window.location.href,
        e_c: this.props.item.category,
        e_a: "WISHLIST",
        e_n: itemId
      });}
    } else {
      let data = { ...this.state.merchantData };
      data.wishlisted = false;
      this.setState({ merchantData: data, });
      document.getElementById(itemId).src = HeartUnFilled;
      document.getElementById(itemId).setAttribute("data", "WISHLIST");
      if(this.props.item.itemType==="PORTFOLIO_OFFERS"){

        interaction("UNDO_WISHLIST", "PORTFOLIO_OFFERS", itemId)
        .then((res) => {})
        .catch((err) => {
          if (err && err.data && err.data.status === 404) {
          } else {
            //   console.log(getError(err));
          }
        });

      }
      else if(this.props.item.itemType==="FINANCIAL_PRODUCT"){
        interaction("UNDO_WISHLIST", "FINANCIAL_PRODUCT", itemId)
        .then((res) => {})
        .catch((err) => {
          if (err && err.data && err.data.status === 404) {
          } else {
            //   console.log(getError(err));
          }
        })
      }
      else{
        interaction("UNDO_WISHLIST", "MERCHANT", itemId)

        .then((res) => {})

        .catch((err) => {

          if (err && err.data && err.data.status === 404) {

          } else {

            //   console.log(getError(err));

          }

        })
      }
      matomo.track({
        url: window.location.href,
        e_c: this.props.item.category,
        e_a: "UNDO_WISHLIST",
        e_n: itemId
      });
    }
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  /* Onclick Function */
  _onChangeTab = (activeMenu) => {
    this.setState({ activeMenu });
  };

  _onClick = () => {
    this.setState({ showMore: true });
  };

  _onChangeCountrySelect = (opt) => {
    this.setState({
      country: opt ? opt.value : "",
      changeCountryCheck: true
    });
  };

  _onClickOutside = (e) => {
    if (
      e.target.id != "settings-icn" &&
      e.target.parentElement.id != "settings-icn"
    ) {
      this.setState({ isPopoverOpen: false });
    }
  };

  settingPopup = (itemId) => {
    const { isPopoverOpen } = this.state;
    this.setState({ isPopoverOpen: !isPopoverOpen });
  };

  sharePopup = (itemId) => {
    if (!this.state.isShareOpen) {
      this.setState({ isShareOpen: true }, () => {
        document.documentElement.style.overflowY = "hidden";
        document.body.style.overflowY = "hidden";
      });
    }
  };

  hideSharePopup = () => {
    this.setState(
      {
        isShareOpen: false
      },
      () => {
        document.documentElement.style.overflowY = "auto";
        document.body.style.overflowY = "auto";
      }
    );
  };

  onLikeChange = (e) => {
    const { item } = this.props;
    const { like, dislike, isPopoverOpen } = this.state;
    this.setState({ like: !like, dislike: false });
    if(this.props.item.itemType==="PORTFOLIO_OFFERS"){
    interaction(e, "PORTFOLIO_OFFERS", item.id)
      .then((res) => {
        this.settingPopup();
      })
      .catch((err) => {
        //   console.log(getError(err));
      });
    }
    else if(this.props.item.itemType==="FINANCIAL_PRODUCT") {
      interaction(e, "FINANCIAL_PRODUCT", item.id)
      .then((res) => {
        this.settingPopup();
      })
      .catch((err) => {
        //   console.log(getError(err));
      });
    }
    else {
      interaction(e, "MERCHANT", item.id)
      .then((res) => {
        this.settingPopup();
      })
      .catch((err) => {
        //   console.log(getError(err));
      });
    }

    matomo.track({
      url: window.location.href,
      e_c: item.category,
      e_a: e,
      e_n: item.id
    });
  };

  onDislikeChange = (e) => {
    const { item, history } = this.props;
    const { dislike, like, isPopoverOpen } = this.state;
    this.setState({ dislike: !dislike, like: false });
    if(this.props.item.itemType==="PORTFOLIO_OFFERS"){
    interaction(e, "PORTFOLIO_OFFERS", item.id)
      .then((res) => {
        this.settingPopup();
        setTimeout(() => {
          this.props.setActiveMenu(sessionStorage.getItem("actMenu") || "home");
          history.push(`/home`);
        }, 500);
      })
      .catch((err) => {
        //   console.log(getError(err));
      });
    }
    else if(this.props.item.itemType==="FINANCIAL_PRODUCT"){
      interaction(e, "FINANCIAL_PRODUCT", item.id)
      .then((res) => {
        this.settingPopup();
        setTimeout(() => {
          this.props.setActiveMenu(sessionStorage.getItem("actMenu") || "home");
          history.push(`/home`);
        }, 500);
      })
      .catch((err) => {
        //   console.log(getError(err));
      });
    }
    else {
      interaction(e, "MERCHANT", item.id)
      .then((res) => {
        this.settingPopup();
        setTimeout(() => {
          this.props.setActiveMenu(sessionStorage.getItem("actMenu") || "home");
          history.push(`/home`);
        }, 500);
      })
      .catch((err) => {
        //   console.log(getError(err));
      });
    }
    matomo.track({
      url: window.location.href,
      e_c: item.category,
      e_a: e,
      e_n: item.id
    });
  };

  redirectSite = () => {
    const lang = localStorage.getItem("language");
    const { item } = this.props;

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-alert">
            <h4 className="text-center">
              {lang === "AR"
                ? arabicContent.redirectMsg
                : `By clicking on 'Proceed' you are  providing  consent to  be redirected to the merchant's website and SmartBuy holds no responsibility for any inconveniences or issues incurred hereafter`}
            </h4>
            <div className="custom-alert-button-group">
              <button
                onClick={() => {
                  matomo.track({
                    url: window.location.href,
                    e_c: item.url,
                    e_a: "REDIRECT_MERCHANT",
                    e_n: item.id
                  });
                  window.open(item.url, "_blank");
                  // document.documentElement.style.overflowY='auto'
                  // document.body.style.overflowY = 'auto';
                  onClose();
                }}
              >
                {lang === "AR" ? arabicContent.proceed : `Proceed`}
              </button>
              <button
                onClick={() => {
                  // document.documentElement.style.overflowY='auto'
                  // document.body.style.overflowY = 'auto';
                  onClose();
                }}
              >
                {lang === "AR" ? arabicContent.cancel : `Cancel`}
              </button>
            </div>
          </div>
        );
      }
    });
  };

  /* Other Render Functions */
  _renderBestOffersMenu(id, item, itemUrl, index, merchantName, merchantItem) {
    const { activeMenu, activeOfferIndex } = this.state;
    // const { item } = this.props;
    const baseURL = item.url;
    const lastItem = 0;
    if (item.offers) {
      const lastItem = item.offers.length - 1;
    } else {
      const lastItem = 0;
    }
    const isActiveOffer = activeOfferIndex === index;

    return (
      <div className="col-md-12 p-0">
         {merchantItem.itemType==="FINANCIAL_PRODUCT"? 
            <BankBestOffer 
            merchantId={id}
            merchantName={merchantName}
            merchantItem={merchantItem}
            itemUrl={itemUrl} 
            item={item} 
            key={`${item.id}`} 
            isActiveOffer={isActiveOffer} 
            baseURL={baseURL} 
            onClick={this.redirectSite}
            from={this.state.from}
            _openLogin={this.props._openLogin}/>
            :
            <BestOffer 
            merchantId={id}
            merchantName={merchantName}
            merchantItem={merchantItem}
            itemUrl={itemUrl} 
            item={item} 
            key={`${item.id}`} 
            isActiveOffer={isActiveOffer} 
            baseURL={baseURL} 
            onClick={this.redirectSite}
            from={this.state.from}
            _openLogin={this.props._openLogin}
            itemType={this.props.item.itemType}
          />
        }
      </div>
    );
  }

  _renderMerchantInfo() {
    const { activeMenu } = this.state;
    const { item } = this.props;
    if (activeMenu !== "info") {
      return null;
    }

    return <MerchantInfo item={item} />;
  }

  _renderReview() {
    const { activeMenu } = this.state;
    if (activeMenu !== "reviews") {
      return null;
    }

    return <Review />;
  }

  _renderCardDetails() {
    const { country, changeCountryCheck } = this.state;
    const { item, countryList } = this.props;
    const contry =
      country && changeCountryCheck ? country : JSON.parse(country).value;

    return (
      <div className="col-md-12 p-0 card-details">
        <div className="col-md-6 p-0 site">
          <a
            // href={item.url}
            // rel="noreferrer"
            // target="_blank"
            className="website ellipsis"
            onClick={this.redirectSite}
          >
            {item.url}
          </a>
        </div>
        {item.isOnline ? (
          <span></span>
        ) : (
          <span>
            <span className="divider" />
            <div className="col-md-6 country-select-merchant p-0">
              <Select
                value={contry}
                isCountryForMerchant
                options={countryList}
                onChange={this._onChangeCountrySelect}
              />
            </div>
          </span>
        )}
      </div>
    );
  }

  async fetchImage(imageUrl) {
    const res = await axios.get(imageUrl);
    const imageBlob = await res.blob();
    const imageObjectURL = URL.createObjectURL(imageBlob);
    if (imageObjectURL) return imageObjectURL;
    else {
      return null;
    }
  }

  _rennderFooterItem() {
    const lang = localStorage.getItem("language");
    const { item } = this.props;
    return (
      config.hasTasteMapScore && this.state.porttype && (
        <div className={this.state.porttype ? "col-md-12 p-0 flex align-items-center pt-18 footlin" : "col-md-12 p-0 flex align-items-center pt-18"}>
          <div className="flex card-footer-taste-div">
            {item.tasteMatchScore > 0 && (
              <div
                className={`flex flex-start align-items-center ${
                  lang === "AR" ? "flex-row_rev" : ""
                }`}
              >
                <div style={{ width: "40px" }}>
                  <GaugeChart
                    id={"merchantDetailsGauge"}
                    className="react-gauge"
                    arcWidth={0.3}
                    arcPadding={0.01}
                    hideText={true}
                    animate={false}
                    // arcsLength={[0.96,0.04]}
                    // percent={0.96}
                    arcsLength={[
                      item.tasteMatchScore / 100,
                      1 - item.tasteMatchScore / 100
                    ]}
                    percent={item.tasteMatchScore / 100}
                    needleColor="#ffffff"
                    colors={["#01C909", "#ffffff"]}
                  />
                </div>
                <div className="taste-match-score">{item.tasteMatchScore}%</div>
              </div>
            )}
            <div className="recommend-text">
              {lang === "AR"
                ? arabicContent.recommendscore
                : `Recommendation Score`}
            </div>
          </div>
          {item && item.tasteMatchScoreReason && (
            <div
              className={`reason-text ${
                lang === "AR" ? "reason-text-ar" : ""
              } ${config.hasTasteMapScore ? "" : "remove-taste-score"}`}
              style={{
                color:
                  uiConfig.config.whitelabel.merchant_details.merchant_tile
                    .color
              }}
            >
              {lang === "AR"
                ? arabicContent.tasteReason
                : item.tasteMatchScoreReason}
            </div>
          )}
        </div>
      )
    );
  }

  _renderPopover() {
    const { item } = this.props;
    const { like, dislike } = this.state;

    return (
      <SettingModal
        item={item}
        hide={this.settingPopup}
        onTypeLikeChange={this.onLikeChange}
        onTypeDislikeChange={this.onDislikeChange}
        likeState={like}
        dislikeState={dislike}
      />
    );
  }

  goBack = () =>
    this.props.history.push("/home/search", {
      searchKeyword: this.props.location.state.from,
      from: "merchantDetails"
    });

  _renderBreadcrumb() {
    const { item, isLoad, _onChangeTab, history } = this.props;
    const minWidth = 1400;
    const city =
      JSON.parse(localStorage.getItem("selectCountry")) ||
      JSON.parse(localStorage.getItem("selectFirstCountry"));
    const { from, category, filterData } = this.props.location.state || "";
    const lang = localStorage.getItem("language");
    const activeMenu = sessionStorage.getItem("activeMenu");
    const actMenu = sessionStorage.getItem("actMenu");
    let catMenu = actMenu !== "home" ? actMenu : null;
    const menu =
      activeMenu !== "undefined"
        ? activeMenu === "claimed"
          ? "Claimed offers"
          : activeMenu
        : catMenu === actMenu
        ? "Home"
        : actMenu || "Home";
    // let selCity = JSON.parse(localStorage.getItem("selectCountry"));

    // let prevMer = JSON.parse(sessionStorage.getItem('prevMerchant'));

    let currMerObj = { id: item?.id, name: item?.name };
    let arr = [];
    arr = JSON.parse(sessionStorage.getItem("merArr")) || [];
    arr.push(currMerObj);
    const ids = arr.map((o) => o.id);
    const filtered = arr.filter(
      ({ id }, index) => !ids.includes(id, index + 1)
    );
    sessionStorage.setItem("merArr", JSON.stringify(filtered));

    let merchantArr = JSON.parse(sessionStorage.getItem("merArr"));
    //  const path = activeMenu!=="undefined" ? activeMenu==="home" ? "/home" : "/home/"+activeMenu:actMenu==="claimed" ? "/home/profile" : "/home";
    let path = "/home";
    if (activeMenu === "claimed") {
      path = "/home/profile";
    } else if (activeMenu === "wishlisted") {
      path = "/home/" + activeMenu;
    } else {
      path = "/home";
    }

    const breadcrumbLinks = [
      { path: path, title: lang === "AR" ? arabicContent.home : menu },
      { title: activeMenu !== "undefined" ? null : city?.label },
      {
        path: "category",
        title:
          activeMenu !== "undefined"
            ? null
            : category?.category
            ? category.category
            : item?.category
      },
      { title: lang === "AR" ? arabicContent.mername : item?.name }
    ];

    // if(prevMer && prevMer?.id === item.id) {
    //   prevMer.name = null;
    // }
    const similarBreadcrumbLinks = [
      { title: merchantArr?.length > 2 ? "..." : null },
      {
        path: `/home/merchant/${merchantArr[merchantArr.length - 2]?.id}`,
        title: merchantArr[merchantArr.length - 2]?.name
      },
      { title: merchantArr[merchantArr.length - 1]?.name }
    ];

    const goBackPage = (pathname) => {
      if (pathname === "/home") {
        _onChangeTab("home");
        sessionStorage.setItem("actMenu", "home");
        history.push(`/home`, "home");
      } else if (pathname === "all offers" || pathname === "nearby_offers" ) {
        let data = filterData && filterData.filterData;
        localStorage.setItem("tab", pathname);
        _onChangeTab(pathname);
        sessionStorage.setItem("actMenu", pathname);
        history.push(`/home`, { from: "merchant" });
      } else if (pathname === "category") {
        _onChangeTab(item?.category || "home");
        sessionStorage.setItem("actMenu", item?.category || "home");
        history.push(`/home`, "home");
      } else {
        history.push(pathname);
      }
    };

    let links = breadcrumbLinks;
    //  if(item?.isOnline) {
    //  links = breadcrumbLinks.filter(({title}) => title !== city?.label );
    //  } else {
    // let nearmeCity = null;
    // if(selCity?.value === "Near me" || selCity?.value === arabicContent.nearMe){
    //   nearmeCity = selCity?.value;
    // }
    // links = breadcrumbLinks.filter(({title}) => title !== nearmeCity );
    //  }
    if (isLoad) {
      return (
        <div className="merchant-breadcrumb p-0">
          <ContentLoader speed={0.7} height={30} width={250}>
            <rect x="0" y="10" rx="5" ry="5" width="250" height="30" />
          </ContentLoader>
        </div>
      );
    }

    return (
      <>
      {this.state.from !== "expired" &&
      <div className="merchant-breadcrumb p-0">
        {typeof from !== "undefined" ? (
          <>
            {from === "home" ? (
              <>
                <Breadcrumb fromPage="home" links={links} goback={goBackPage} />
              </>
            ) : from === "wishlist" ? (
              <>
                <Breadcrumb links={links} goback={goBackPage} />
              </>
            ) : (
              <div className="bcm cursor" onClick={this.goBack}>
                <Icon
                  name="arrowLeft"
                  width={12}
                  height={14}
                  fill={uiConfig.config.whitelabel.festiveTreats?"#000":"#fff"}
                />
                <div className="bcm-lnk bcm-backtoresult">
                  {lang === "AR"
                    ? arabicContent.backtoresult
                    : `Back to Results`}
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {this.props.location?.state?.page === "claimed" ? (
              <>
                {/* <div className="bcm" data-testid="bcm">
                <div className="bcm-lnk cursor" data-testid={"bcm"} onClick={()=>goBackPage("/home")} title={"home"}>Home</div>
                <div className="bcm-spl">
                  <span className="bc_spl">/</span>
                </div>
                <div className="bcm-lnk last">{ lang === "AR" ? arabicContent.mername : item?.name }</div>
              </div> */}
                <Breadcrumb links={links} goback={goBackPage} />
              </>
            ) : (
              <Breadcrumb
                links={similarBreadcrumbLinks}
                goback={goBackPage}
                isSimilar={true}
              />
            )}
          </>
        )}
          </div>
          } 
          </> 
    );
  }

  /* Other Render Functions */
  _renderNormalView(item) {
    const minWidth = 768;
    const { imgSrc } = this.state;
    let lang = localStorage.getItem("language");
    if (minWidth < this.state.width && item) {
      return (
        <div
          className="col-md-12 p-0 merchant-img-div"
          style={uiConfig.config.whitelabel.merchant_details.merchant_tile}
        >
          {uiConfig.config.whitelabel.merchant_details.detailBg && (<img
              src={
                lang === "AR"
                  ? merchant_detail_background_ar
                  : merchant_detail_background
              }
              alt="detail-bg"
              className={`detail-bg ${lang === "AR" ? "detail-bg-ar" : ""}`}
              />)}
              <div
                style={uiConfig.config.whitelabel.merchant_details.merchant_details}
                className={`col-md-12 p-0 merchant-img-content ${
                  lang === "AR" ? " merchant-img-content-ar" : ""
                }`}
              >
            <div className="flex flex-between merchant-details-breadcrumb">
              <div>{this._renderBreadcrumb()}</div>
              {this.state.from !== "expired" && 
              <div className="flex">
                <div className={`${lang === "AR" ? "ml-20" : "mr-20"}`}>
                  {/* {item && item.wishlisted ? ( */}
                    <img
                      src={this.state.merchantData.wishlisted? HeartFilled:HeartUnFilled}
                      style={{
                        cursor: "pointer",
                        width: "24px",
                        height: "21px"
                      }}
                      onClick={() =>
                        this.userInteraction(item.id, this.state.merchantData.wishlisted? "UNDO_WISHLIST":"WISHLIST")
                      }
                      id={item.id}
                      data={this.state.merchantData.wishlisted? "UNDO_WISHLIST":"WISHLIST"}
                      alt=""
                    />
                  {/* ) : (
                    <img
                      src={HeartUnFilled}
                      style={{
                        cursor: "pointer",
                        width: "24px",
                        height: "21px"
                      }}
                      onClick={() => this.userInteraction(item.id, "WISHLIST")}
                      id={item.id}
                      data="WISHLIST"
                    />
                  )} */}
                </div>

                <div
                  className={`${lang === "AR" ? "ml-20" : "mr-20"}`}
                  style={{ cursor: "pointer" }}
                  onClick={this.sharePopup}
                >
                  <Icon name="connect" width={18} height={21} fill="#000" />
                  {this.state.isShareOpen && (
                    <ShareModal
                      // item={item}
                      hide={this.hideSharePopup}
                      isModalOpen={this.state.isShareOpen}
                      item={this.props.item}
                    />
                  )}
                  <div></div>
                </div>

                <div
                  id="settings-icn"
                  className={`${
                    lang === "AR" ? "settings-icn-ar" : "settings-icn"
                  }`}
                  style={{ cursor: "pointer" }}
                  onClick={() => this.settingPopup(item.id)}
                >
                   <Icon name={uiConfig.config.whitelabel.festiveTreats? "setting_bl":"settings"} width={18} height={21} fill="#000" />
                  {/* <img src={settings1} style={{height:"24px"}} /> */}
                  <Popover
                    isOpen={this.state.isPopoverOpen}
                    onClickOutside={(e) => this._onClickOutside(e)}
                    content={() => (
                      <div
                        className={`merchant-popup-taste-n ${
                          lang === "AR" ? "merchant-popup-taste-ar-n" : ""
                        }`}
                      >
                        {this._renderPopover()}
                      </div>
                    )}
                  >
                    <div></div>
                  </Popover>
                </div>
              </div>  }
            </div>
            <div className="col-lft flex _ai-c">
              <div
                style={{
                  backgroundColor: item.dominantColorCode
                    ? item.dominantColorCode
                    : "#ffffff",
                  position: "relative",
                  borderRadius: "8px",
                  height: "187px",
                  width: "300px",
                  objectFit:"cover"
              }}
              id={"mycard_"+item.id}>
                <img style={{borderRadius: "8px"}} height="100%" src={`${config.optimoleURL}/rs:fill:320:200/q:84/${(item?.brandLogo)? item.brandLogo: (item?.curatedImage)? item?.curatedImage : item?.image }`} width="100%"></img>
                {item.merchantType &&
        <div className={`col-lft-desk ${lang === 'AR' ? "col-lft-desk-ar" : ""}`} style={uiConfig.config.whitelabel.merchant_details.merchant_img}>
        {
                     item.itemType==="FINANCIAL_PRODUCT"? 
                     lang === 'AR' ? 
                     item.merchantType.length === 2 ? arabicContent.bankBoth:
                     item.merchantType[0]==="online" ? arabicContent.bankOnline : arabicContent.bankInstore : 
                     item.merchantType.length === 2 ? `Bank & Online + Instore`:
                     item.merchantType[0]==="online" ? `Bank & Online` : `Bank & Instore`:
                     lang === 'AR' ? 
                     item.merchantType.length === 2 ? arabicContent.both:
                     item.merchantType[0]==="online" ? arabicContent.online : arabicContent.instore : 
                     item.merchantType.length === 2 ? `Online + Instore`:
                     item.merchantType[0]==="online" ? `Online` : `Instore`
                     }  
        </div>
    }
         {/* {uiConfig.config.whitelabel.clientName === "hdfc" ?
                  objectFit: "cover"
                }}
                id={"mycard_" + item.id}
              >
                <img
                  style={{ borderRadius: "8px" }}
                  height="100%"
                  src={`https://mlca6kbxnopy.i.optimole.com/rs:fill:320:200/q:84/${
                    item?.image
                    ? item?.image
                    : item?.brandLogo 
                  }`}
                  width="100%"
                ></img>
                {item.merchantType && (
                  <div
                  className={`col-lft-desk ${
                    lang === "AR" ? "col-lft-desk-ar" : ""
                  }`}
                  style={
                    uiConfig.config.whitelabel.merchant_details.merchant_img
                  }
                >
                 {
                    item.merchantType.length === 2 ? `Online + Instore`:
                    item.merchantType[0]==="online" ? `Online` : `Instore`
                  }
                </div>
                )}
                {/* {uiConfig.config.whitelabel.clientName === "hdfc" ?
            <div
              className="card-image-merch"
              style={{
                margin: "4px 0",
                backgroundColor: item.dominantColorCode
                  ? item.dominantColorCode
                  : "#ffffff",
                backgroundImage: `url("https://mlca6kbxnopy.i.optimole.com/rs:fit:320:200/q:84/${item?.curatedImage?item.curatedImage:item?.image}")`
              }}
            ></div> 
            : 
            <div className="flex-center" style={{minHeight: "180px"}}>
            <img src={"https://logo.clearbit.com/"+item.url+"?size=800"}  style={{margin:"10px",maxHeight: "160px",maxWidth: "100%"}} onError={(e)=>{if(item.image){e.target.onerror = null; e.target.src=item.image.replace(/ /g, "%20")}}} loading="eager"/> 
              {
                item.curatedImage ? 
                <img src={item.curatedImage} style={{margin:"0px",borderRadius:"8px",maxHeight: "180px",width: "100%"}} loading="eager"/>
                :
                <img src={"https://logo.clearbit.com/"+item.url+"?size=800"}  style={{margin:"10px",maxHeight: "160px",maxWidth: "100%"}} onError={(e)=>{if(item.image){e.target.onerror = null; e.target.src=item.image.replace(/ /g, "%20")}}} loading="eager"/>
              }
            </div>
          } */}
              </div>

              <div
                className={`card-info ${lang === "AR" ? "card-info-ar" : ""}`}
              >
                <div
                  className="margin-0 item-title"
                  style={{
                    color:
                      uiConfig.config.whitelabel.merchant_details.merchant_tile
                        .color
                  }}
                >
                  {lang === "AR" ? item.name : item.name}
                </div>
                <div className={`flex margin-0 p-0`}>
                  <span
                     className={
                      !this.state.porttype || this.state.from === "expired" ? "item-des-port" : "item-des"}
                    style={{
                      color:
                        uiConfig.config.whitelabel.merchant_details
                          .merchant_tile.color
                    }}
                  >
                    {lang === "AR"
                      ? toTitleCase(item.category)
                      : toTitleCase(item.category)}
                  </span>
                  <span>
                  {this.state.porttype && (
                  <span className="website">
                    <a
                      // href={item.url}
                      // rel="noreferrer"
                      // target="_blank"
                      className="website ellipsis"
                      onClick={this.redirectSite}
                      style={
                        uiConfig.config.whitelabel.urlColor
                          ? { color: uiConfig.config.whitelabel.urlColor }
                          : { color: uiConfig.config.whitelabel.brandColor }
                      }
                    >
                      {item.url}
                    </a>
                  </span>
                  )}
                  </span>
                </div>
                {item&&(item.itemType==="FINANCIAL_PRODUCT"?"":item.tasteMatchScore&&this._rennderFooterItem())}
              </div>
            </div>
          </div>
        </div>
      );
    }

    return null;
  }

  _renderMobileView(item) {
    const minWidth = 768;
    const { imgSrc } = this.state;
    let lang = localStorage.getItem("language");
    if (minWidth >= this.state.width && item) {
      return (
        <div className="col-md-12 p-0">
          {uiConfig.config.whitelabel.merchant_details.detailBg && (<img
              src={
                lang === "AR"
                  ? merchant_detail_background_ar
                  : merchant_detail_background
              }
              alt="detail-bg"
              className={`detail-bg ${lang === "AR" ? "detail-bg-ar" : ""}`}
            />)}
          <div
            className="col-md-12 p-0 merchant-img-content mbl"
            style={uiConfig.config.whitelabel.merchant_details.merchant_tile}
          >
             <div className="flex flex-between merchant-details-breadcrumb">
            {/* <img
              src={
                lang === "AR"
                  ? merchant_detail_background_ar
                  : merchant_detail_background
              }
              alt="detail-bg"
              className={`detail-bg ${lang === "AR" ? "detail-bg-ar" : ""}`}
            /> */}
            {/* <div className="flex flex-between merchant-details-breadcrumb" style={{position:"relative"}}> */}
              <div>{this._renderBreadcrumb()}</div>
              {this.state.from !== "expired" &&
              <div className="flex">
                <div className={`${lang === "AR" ? "ml-18" : "mr-18"}`}>
                  {/* {item && item.wishlisted ? ( */}
                    <img
                      src={this.state.merchantData.wishlisted ? HeartFilled:HeartUnFilled}
                      style={{
                        cursor: "pointer",
                        width: "19px",
                        height: "17px"
                      }}
                      onClick={() =>
                        this.userInteraction(item.id, this.state.merchantData.wishlisted ? "UNDO_WISHLIST":"WISHLIST")
                      }
                      id={item.id}
                      data={this.state.merchantData.wishlisted ? "UNDO_WISHLIST":"WISHLIST"}
                      alt=""
                    />
                  {/* ) : (
                    <img
                      src={HeartUnFilled}
                      style={{
                        cursor: "pointer",
                        width: "19px",
                        height: "17px"
                      }}
                      onClick={() => this.userInteraction(item.id, "WISHLIST")}
                      id={item.id}
                      data="WISHLIST"
                    />
                  )} */}
                </div>

                <div
                  className={`${lang === "AR" ? "ml-18" : "mr-18"}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => this.sharePopup(item.id)}
                >
                  <Icon name={uiConfig.config.whitelabel.festiveTreats? "connect_bl":"connect"} width={15} height={17} fill="#fff" />
                  {this.state.isShareOpen && (
                    <ShareModal
                      //item={item}
                      hide={this.hideSharePopup}
                      isModalOpen={this.state.isShareOpen}
                      item={this.props.item}
                    />
                  )}
                  <div></div>
                </div>
                <div
                  id="settings-icn"
                  className="settings-icn-mbl"
                  style={{ cursor: "pointer" }}
                  onClick={() => this.settingPopup(item.id)}
                >
                  <Icon name={uiConfig.config.whitelabel.festiveTreats? "setting_bl":"settings"} width={6} height={18} fill="" />
                  <Popover
                    isOpen={this.state.isPopoverOpen}
                    onClickOutside={(e) => this._onClickOutside(e)}
                    content={() => (
                      <div
                        className={`merchant-popup-more-like ${
                          lang === "AR" ? "merchant-popup-more-like-ar" : ""
                        }`}
                      >
                        {this._renderPopover()}
                      </div>
                    )}
                  >
                    <div></div>
                  </Popover>
                </div>
                </div>
              }
            </div>
            <div className="col-lft align-card">
        <div className="card-section-top mbl">
          <div className={`merchant-details-img-content-mbl`} style={{padding: "0px",objectFit:"cover", borderRadius: "8px"}}   id={"mycard_"+item.id}>
          
          <img style={{borderRadius:"8px"}} src={`${config.optimoleURL}/w:400/h:400/q:85/rs:fit/${(item?.brandLogo)? item.brandLogo: (item?.curatedImage)? item?.curatedImage : item?.image }`} height="100%" width="100%"></img>
        
          <div 
          className={`col-lft ${lang === 'AR' ? "col-lft-ar" : ""}`}>
           {
                     item.itemType==="FINANCIAL_PRODUCT"? 
                     lang === 'AR' ? 
                     item.merchantType.length === 2 ? arabicContent.bankBoth:
                     item.merchantType[0]==="online" ? arabicContent.bankOnline : arabicContent.bankInstore : 
                     item.merchantType.length === 2 ? `Bank & Online + Instore`:
                     item.merchantType[0]==="online" ? `Bank & Online` : `Bank & Instore`:
                     lang === 'AR' ? 
                     item.merchantType.length === 2 ? arabicContent.both:
                     item.merchantType[0]==="online" ? arabicContent.online : arabicContent.instore : 
                     item.merchantType.length === 2 ? `Online + Instore`:
                     item.merchantType[0]==="online" ? `Online` : `Instore`
                     }
          </div>
          {/* <div
            <div className="col-lft align-card"  style={{position:"relative"}}>
              <div className="card-section-top mbl">
                <div
                  className={`merchant-details-img-content-mbl`}
                  style={{
                    padding: "0px",
                    objectFit: "cover",
                    borderRadius: "8px"
                  }}
                  id={"mycard_" + item.id}
                >
                  <img
                    style={{ borderRadius: "8px" }}
                    src={`https://mlca6kbxnopy.i.optimole.com/w:400/h:400/q:85/rs:fit/${
                      item?.image
                        ? item?.image
                        : item?.brandLogo  
                    }`}
                    height="100%"
                    width="100%"
                  ></img>
                  {item.merchantType && (
                    <div
                    className={`col-lft ${lang === "AR" ? "col-lft-ar" : ""}`}
                  >
                    {
                    item.merchantType.length === 2 ? `Online + Instore`:
                    item.merchantType[0]==="online" ? `Online` : `Instore`
                  }
                  </div>
                  )}
                  {/* <div
              className="card-image-merch"
              style={{
                minHeight: "99%",
                backgroundColor: item.dominantColorCode
                  ? item.dominantColorCode
                  : "#ffffff",
                backgroundImage: `url("https://mlca6kbxnopy.i.optimole.com/w:320/h:200/q:85/rs:fit/${item?.curatedImage?item.brandLogo:item?.image}")`
              }}
            ></div>  */}
                  {/* <div className="flex-center mer-img">
               <img src={"https://logo.clearbit.com/"+item.url+"?size=800"} width={80} height={80} style={{margin:"10px",objectFit:'contain'}} onError={(e)=>{if(item.image){e.target.onerror = null; e.target.src=item.image.replace(/ /g, "%20")}}} loading="eager"/>
              {
              item.curatedImage ? 
              <img src={item.curatedImage} width={80} height={80} style={{margin:"10px",objectFit:'contain'}} loading="eager"/>
              :
              <img src={"https://logo.clearbit.com/"+item.url+"?size=800"} width={80} height={80} style={{margin:"10px",objectFit:'contain'}} onError={(e)=>{if(item.image){e.target.onerror = null; e.target.src=item.image.replace(/ /g, "%20")}}} loading="eager"/>
              }
            </div> */}
                </div>

                <div
                  className={`card-info ${lang === "AR" ? "card-info-ar" : ""}`}
                >
                  <div
                    className="margin-0 item-title mbl"
                    style={{
                      color:
                        uiConfig.config.whitelabel.merchant_details
                          .merchant_tile
                    }}
                  >
                    {lang === "AR" ? arabicContent.mername : item.name}
                  </div>
                  <div
                    className={`margin-0 flexPad ${lang === "AR" ? "" : ""}`}
                  >
                    <span
                      className="item-des mbl"
                      style={{
                        color:
                          uiConfig.config.whitelabel.merchant_details
                            .merchant_tile.color
                      }}
                    >
                      {lang === "AR"
                        ? arabicContent.mercate
                        : toTitleCase(item.category)}
                    </span>
                    {/* <span className="website mbl">
            <a
            // href={item.url}
              // rel="noreferrer"
              // target="_blank"
              className="website mbl ellipsis"
              onClick={this.redirectSite}
              style={{color:uiConfig.config.whitelabel.urlColor ? uiConfig.config.whitelabel.urlColor:uiConfig.config.whitelabel.brandColor}}
            >
              {item.url}
            </a>
            </span> */}
                  </div>
                </div>
              </div>
              <div className="card-section-bottom">
                <div
                  className={`card-info ${lang === "AR" ? "card-info-ar" : ""}`}
                >
                  {item && item.tasteMatchScore && this._rennderFooterItem()}
                </div>
              </div>
            </div>
        </div>
        </div>
      );
    }

    return null;
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.cardItem &&
      this.state.cardItem.name !== nextProps.cardItem.name
    ) {
      this.setState({ cardItem: nextProps.cardItem });
    }
    this.setState({ activeOfferIndex: -1 });
  }

  toggleCard = (index) => {
    this.setState({
      activeOfferIndex: index
    });
  };

  /* Main Render Functions */
  render() {
    const { item, allOffersList } = this.props;
    const { activeMenu, isLoad, isPopoverOpen, isShareOpen, expirePopup } =
      this.state;
    const numberOfItems = this.state.showMore
      ? allOffersList && allOffersList.length
      : 3;
    const cardList = allOffersList && allOffersList.slice(0, numberOfItems);
    const minWidth = 768;

    return (
      <>
        {expirePopup && (
          <div className="expire-popup">
            <div className="content-block">
              <div>
                <div className="fl-center expire-header">
                  <Icon name="clock" width={148} height={148} />
                </div>
                <div
                  className="text-center mt-18"
                  style={{
                    fontWeight: 600,
                    fontSize: "30px",
                    color: "#000811"
                  }}
                >
                  Oops!
                </div>
                {this.state.from !== "expired" && <div
                  className="text-center"
                  style={{
                    fontSize: "18px",
                    color: "#727272",
                    lineHeight: "25px",
                    marginTop: "5px"
                  }}
                >
                  The Offer you are looking for has expired
                  </div>}
                {this.state.from === "expired" && <div
                  className="text-center  expire-footer"
                  style={{
                    fontSize: "18px",
                    color: "#727272",
                    lineHeight: "25px",
                    marginTop: "5px"
                  }}
                >
                  This merchant has no expired offers
                </div>}
                {this.state.from !== "expired"&& 
                <>
                <div
                  className="text-center cursor btn-div"
                  onClick={() => {
                    this.setState({ expirePopup: false });
                    let offsetTop = this.simRef.current.offsetTop;
                    window.scrollTo(0, offsetTop);
                  }}
                  style={{
                    fontWeight: 600,
                    fontSize: "17px",
                    color: "#FFFFFF",
                    backgroundColor: "#0071E6",
                    borderRadius: "8px",
                    margin: "52px 70px 14px 70px",
                    padding: "16px 0px"
                  }}
                >
                  View Similar Merchant Offers
                </div>
                <div
                  className="text-center expire-footer"
                  style={{ fontSize: "14px", color: "#727272" }}
                >
                  Redirecting to Homepage in 15 Seconds
                </div> </>}
              </div>
            </div>
          </div>
        )}
        <div className="col-md-12 merchant-details">
          <div className="main-content">
            <div className="col-left col-md-9 p-0">
              {this._renderNormalView(item)}
              {this._renderMobileView(item)}
              {this.state.country.stateValue &&
                this.state.IsCurLocation === true && this.state.porttype &&
                item?.filterOffersByLocation && (
                  <div >
                  <div className="offerHdrDiv" >
                  <span style={{marginTop:"40px" , display:"block"}}>
                    Offers available in {this.state.country?.value }, {this.state.country.stateValue}
                    </span>
                  </div>
                  <div className="Hdrline"></div>
                  </div>
                )
              }
              {!this.state.country.stateValue &&
               this.state.IsCurLocation === true && this.state.porttype &&
                item?.filterOffersByLocation && (
                  <div>
                  <div className="offerHdrDiv">
                  <span style={{marginTop:"40px" , display:"block"}}>
                    Offers available {this.state.near && "in"} {this.state.country.value}</span>
                  </div>
                  <div className="Hdrline"></div>
                  </div>
                )
              }
              {item &&
                item.offers &&
                item.offers.length > 0 &&
                item.offers.map((itemoffer, index) => (
                  <>
                  {itemoffer?.currentLocation && (
                    <div className="offerDiv">
                      <div
                        className="col-md-12 p-0 offer-info"
                        style={{
                          backgroundColor: itemoffer?.isExpired || this.state.from === "expired"
                            ?  "#FFF7F7"
                       : `#D0E7FF`

                        }}
                        onClick={() => this.toggleCard(index)}
                      >
                        {/* <div className="col-md-2">
                  <MenuBar
                    activeMenu={activeMenu}
                    onChangeTab={this._onChangeTab}
                  />
                </div> */}
                          <div className="col-md-12 p-0 col-item-rgt">
                            {this._renderBestOffersMenu(
                              item.id,
                              itemoffer,
                              item.url,
                              index,
                              item.name,
                              item,
                              this.expandedMenu,
                              itemoffer?.isExpandedMenus
                            )}
                            {this._renderMerchantInfo()}
                            {this._renderReview()}
                          </div>
                      </div>
                    </div>
                  )}
                  </>
                ))}
                {this.state.IsOtherLocation === true &&  this.state.porttype &&
                item?.filterOffersByLocation && (
                  <div>
                    
                  <div className="offerHdrDiv">
                  <span style={{marginTop:"40px" , display:"block"}}>
                    Offers available in other locations
                    </span>
                  </div>
                  
                  <div className="Hdrline"></div>
                  </div>
                )}
              
              {item &&
                item.offers &&
                item.offers.length > 0 &&
                item.offers?.map(
                  (itemoffer, index) => (
                    (
                      <>
                        {!itemoffer?.currentLocation && (
                          <div className="offerDiv">
                            <div
                              className="col-md-12 p-0 offer-info"
                              style={{
                                backgroundColor: itemoffer?.isExpired || this.state.from === "expired"
                                ?"#FFF7F7"
                                : uiConfig.config.whitelabel.merchant_details.offer_cards.cardofferinfo
                              }}
                              onClick={() => this.toggleCard(index)}
                            >
                              {/* <div className="col-md-2">
                  <MenuBar
                    activeMenu={activeMenu}
                    onChangeTab={this._onChangeTab}
                  />
                </div> */}
                              <div className="col-md-12 p-0 col-item-rgt">
                                {this._renderBestOffersMenu(
                                  item.id,
                                  itemoffer,
                                  item.url,
                                  index,
                                  item.name,
                                  item,
                                  this.expandedMenu,
                                  itemoffer?.isExpandedMenus
                                )}
                                {this._renderMerchantInfo()}
                                {this._renderReview()}
                              </div>
                            </div>
                          </div>
                        )}
                      </>
                    )
                  )
                )}
            </div>
            {this.state.from !=="expired" &&
            <div className=" col-md-12 p-0 page-title similarDiv" ref={this.simRef}>
              {minWidth < this.state.width && isLoad && (
                <div className="flex-center">
                  <ContentLoader speed={0.7} width={230} height={240}>
                    <rect x="0" y="0" rx="5" ry="5" width="230" height="100" />
                    <rect x="0" y="110" rx="4" ry="4" width="230" height="13" />
                    <rect x="0" y="130" rx="3" ry="3" width="230" height="10" />
                    <rect x="0" y="150" rx="3" ry="3" width="230" height="10" />
                    <rect x="0" y="170" rx="3" ry="3" width="230" height="10" />
                    <rect x="0" y="190" rx="3" ry="3" width="230" height="10" />
                  </ContentLoader>
                </div>
              )}
             {!isLoad && allOffersList.length > 0 && this.state.from !== "expired" && (this.props.item.itemType!=="FINANCIAL_PRODUCT") && (
                <span key={Math.random()}>
                  <SimilarMerchants
                    _openLogin={this.props._openLogin}
                    itemList={allOffersList}
                    history={this.props.history}
                    checkColor={this.checkColor}
                    itemType={this.state.porttype}
                  />
                </span>
              )}
            </div> }
          </div>
        </div>
      </>
    );
  }
}
export default withRouter(MerchantDetails);
